export default {
    category: null,
    products: [],
    pagination: [],
};
